import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBTableBody, MDBTable, MDBTableHead, } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Descriptions   } from 'antd';
import { api, URL } from '../../api';


export default class ModeldeanDescription extends Component {
    constructor(props) {
              super(props);
      this.state = {
        modal: false,
        Curriculumopen_ID :'',
        Course_ID :'',
        Course_YEAR :'',
        Curriculumopen_TEAM :'',
        Curriculumopen_Full_Name_TH:'',
        Curriculumopen_Full_Name_EN:'',
        Curriculumopen_Detail_TH:'',
        Curriculumopen_Detail_EN:'',
        Curriculumopen_CH:'',
        Curriculumopen_Date_START:'',
        Curriculumopen_Date_END:'',
        Univ_ID:'',
        plan:[],

        
      }

this.getplan = this.getplan.bind(this);

}


toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }


  getplan() {
    setTimeout(() => {
       //ภายใน
       api.get('index/searchplan/'+this.props.Curriculumopen_ID)
       .then(res => {
       //  console.log(res);
       //  this.setState({ bankname: res.data, loading: false })
         this.setState({ plan: res.data})
       }) 
     }, 0);
  }

  componentDidMount() {

    //const { id_send } = this.props.id_send
    console.log(this.props.Curriculumopen_ID);
    this.setState({ Curriculumopen_ID:this.props.Curriculumopen_ID}) 
   const id = this.props.Curriculumopen_ID;
  
    api.get('index/getCurriculumdetal/'+id,
    //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
      //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
              {headers: {
              // Authorization: 'Bearer ' + localStorage.getItem('myData')
              }
              })
             
              .then(res => {
              // console.log(res.data[0].id)
            
              this.setState({ Curriculumopen_ID : res.data[0].Curriculumopen_ID });
              this.setState({ Course_ID : res.data[0].Course_ID });
              this.setState({ Course_YEAR : res.data[0].Course_YEAR });
              this.setState({ Curriculumopen_TEAM : res.data[0].Curriculumopen_TEAM });
              this.setState({ Curriculumopen_Full_Name_TH : res.data[0].Curriculumopen_Full_Name_TH });
              this.setState({ Curriculumopen_Full_Name_EN : res.data[0].Curriculumopen_Full_Name_EN });
              this.setState({ Curriculumopen_Detail_TH : res.data[0].Curriculumopen_Detail_TH });
              this.setState({ Curriculumopen_Detail_EN : res.data[0].Curriculumopen_Detail_EN });
              this.setState({ Curriculumopen_CH : res.data[0].Curriculumopen_CH });
              this.setState({ Curriculumopen_Date_START : res.data[0].Curriculumopen_Date_START });
              this.setState({ Curriculumopen_Date_END : res.data[0].Curriculumopen_Date_END });
              this.setState({ Univ_ID : res.data[0].Univ_ID });
              
              //    const Curriculumopen = res.data;
               //   this.setState({ Curriculumopen });
       }) 
       this.getplan();
    }
  

    render() {
        return (
            <>
               
                    <MDBBtn onClick={this.toggle} color="secondary" >รายละเอียดหลักสูตร</MDBBtn>
                    <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
                        <MDBModalHeader toggle={this.toggle}>รายละเอียดหลักสูตร</MDBModalHeader>
                        <MDBModalBody>
                                <Descriptions title="ข้อมูลหลักสูตร" layout="vertical" bordered>
                                    <Descriptions.Item label="ชื่อภาษาไทย">{this.state.Curriculumopen_Full_Name_TH}</Descriptions.Item>
                                    <Descriptions.Item label="ชื่อภาษาอังกฤษ">{this.state.Curriculumopen_Full_Name_EN}</Descriptions.Item>
                                    <Descriptions.Item label="หลักสูตรปี">{this.state.Course_YEAR}</Descriptions.Item>
                                    <Descriptions.Item label="คำอธิบายรายวิชา TH">{this.state.Curriculumopen_Detail_TH === null  ? <>-</>:<>{this.state.Curriculumopen_Detail_TH}</>}</Descriptions.Item>
                                    <Descriptions.Item label="คำอธิบายรายวิชา EN">{this.state.Curriculumopen_Detail_EN === null  ? <>-</>:<>{this.state.Curriculumopen_Detail_EN}</>}</Descriptions.Item>
                                    <Descriptions.Item label="จำนวนชั่วโมง">{this.state.Curriculumopen_CH} ชั่วโมง</Descriptions.Item>
                                    {/* <Descriptions.Item label="Usage Time" span={2}>
                                    2019-04-24 18:00:00
                                    </Descriptions.Item> */}
                                    {/* <Descriptions.Item label="Status" span={3}>
                                    <Badge status="processing" text="Running" />
                                    </Descriptions.Item> */}
                                    <Descriptions.Item label="วันที่เริ่ม">{this.state.Curriculumopen_Date_START}</Descriptions.Item>
                                    <Descriptions.Item label="วันที่สิ้นสุด">{this.state.Curriculumopen_Date_END}</Descriptions.Item>
                                    <Descriptions.Item label="จำนวนที่รับ">{this.state.Curriculumopen_NUM} คน</Descriptions.Item>
                                  
                                </Descriptions>
                                <br/>
                                <p className="font-weight-bold">แผนการสอน</p>  


                                <MDBTable small responsiveMd>
                                <MDBTableHead>
                                    <tr>
                                    <th>#</th>
                                    <th>สัปดาห์ที่</th>
                                    <th>หัวข้อ/รายละเอียด</th>
                                    <th>จำนวนชั่วโมง</th>
                                    <th>กิจกรรม</th>
                                    <th>ผู้สอน/วิทยากร</th>
                                    
                                    </tr>
                                </MDBTableHead>

                                <MDBTableBody>
                                {this.state.plan.map((plan,index) => {
                                  return  <tr>
                                    <td>{index+1}</td>
                                    <td>{plan.Plan_Week }</td>
                                    <td>{plan.Plan_Title }</td>
                                    <td>{plan.Plan_Ch }</td>
                                    <td>{plan.Plan_Activity }</td>
                                    <td>{plan.Teacher_NAME } {plan.Teacher_LASTNAME }</td>
                                   
                                   
                                    </tr>
                                   })}  
                                </MDBTableBody>
                            </MDBTable>      




                        </MDBModalBody>
                        <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                        </MDBModalFooter>
                    </MDBModal>
               
            </>
        )
    }
}
